import { SET_TOKEN, SET_USER, LOGOUT, SET_USER_DETAIL } from './types'
import * as auth from "@/services/auth"
import { setAuthorizationHeader } from "@/services/index"

export default {
  async setUser({ commit }, data) {
    setAuthorizationHeader("c2VsZmNhcmU6c2VsZmNhcmU=");
    const resp = await auth.signin(data.username, data.password);
    commit(SET_USER, resp.data);
  },
  setToken({ commit }, data) {
    commit(SET_TOKEN, data);
  },
  logout({ commit }) {
    commit(LOGOUT);
  },
  setUserDetail({ commit }, data) {
    commit(SET_USER_DETAIL, data);
  },
}
